/* @flow */
/* eslint-disable camelcase */
/* eslint-disable babel/no-invalid-this */
import type { WindowShadeOpenCloseStopFeature } from "./types";

export default function WindowShadeOpenCloseStop(
  feature: WindowShadeOpenCloseStopFeature
) {
  const openAction = feature.actions.open;
  const stopAction = feature.actions.stop;
  const closeAction = feature.actions.close;

  this.open = () => {
    return this.executeDeviceAction(openAction, {});
  };

  this.close = () => {
    return this.executeDeviceAction(closeAction, {});
  };

  this.stop = () => {
    return this.executeDeviceAction(stopAction, {});
  };

  return { percent_open: feature.percent_open };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/window_shade_open_close_stop.js